"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enAU = exports.enCA = exports.enGB = exports.thTH = exports.ptPT = exports.zhHans = exports.ptBr = exports.plPL = exports.nlNL = exports.esMX = exports.jaTMNF = exports.jaJP = exports.itIT = exports.fr = exports.esES = exports.deDE = exports.deCH = exports.frFR = exports.enUS = void 0;
const types_1 = require("./types");
exports.enUS = {
    symbol: 'en-US',
    dateFormat: types_1.DateFormat.DEFAULT,
    nameFormat: types_1.NameFormat.DEFAULT,
    options: {
        currency: {
            style: 'currency',
            currencyDisplay: 'symbol',
            currency: 'USD',
        },
        decimal: {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        },
    },
};
exports.frFR = {
    symbol: 'fr-FR',
    dateFormat: types_1.DateFormat.DEFAULT,
    nameFormat: types_1.NameFormat.DEFAULT,
    options: {
        currency: {
            style: 'currency',
            currencyDisplay: 'symbol',
            currency: 'EUR',
        },
        decimal: {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        },
    },
};
exports.deCH = {
    symbol: 'de-CH',
    dateFormat: types_1.DateFormat.DEFAULT,
    nameFormat: types_1.NameFormat.DEFAULT,
    options: {
        currency: {
            style: 'currency',
            currencyDisplay: 'symbol',
            currency: 'CHF',
        },
        decimal: {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        },
    },
};
exports.deDE = {
    symbol: 'de-DE',
    dateFormat: types_1.DateFormat.DEFAULT,
    nameFormat: types_1.NameFormat.DEFAULT,
    options: {
        currency: {
            style: 'currency',
            currencyDisplay: 'symbol',
            currency: 'EUR',
        },
        decimal: {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        },
    },
};
exports.esES = {
    symbol: 'es-ES',
    dateFormat: types_1.DateFormat.DEFAULT,
    nameFormat: types_1.NameFormat.DEFAULT,
    options: {
        currency: {
            style: 'currency',
            currencyDisplay: 'symbol',
            currency: 'EUR',
        },
        decimal: {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        },
    },
};
exports.fr = {
    symbol: 'fr',
    dateFormat: types_1.DateFormat.DEFAULT,
    nameFormat: types_1.NameFormat.DEFAULT,
    options: {
        currency: {
            style: 'currency',
            currencyDisplay: 'symbol',
            currency: 'EUR',
        },
        decimal: {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        },
    },
};
exports.itIT = {
    symbol: 'it-IT',
    dateFormat: types_1.DateFormat.DEFAULT,
    nameFormat: types_1.NameFormat.DEFAULT,
    options: {
        currency: {
            style: 'currency',
            currencyDisplay: 'symbol',
            currency: 'EUR',
        },
        decimal: {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        },
    },
};
exports.jaJP = {
    symbol: 'ja-JP',
    dateFormat: types_1.DateFormat.JP,
    nameFormat: types_1.NameFormat.JP,
    options: {
        currency: {
            style: 'currency',
            currencyDisplay: 'symbol',
            currency: 'JPY',
        },
        date: {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        },
        decimal: {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
        },
    },
};
// TODO: Confirm we still need to display currencies differently for TMNF
exports.jaTMNF = Object.assign(Object.assign({}, exports.jaJP), { symbol: 'ja-TMNF', dateFormat: types_1.DateFormat.JP, nameFormat: types_1.NameFormat.DEFAULT, options: Object.assign(Object.assign({}, exports.jaJP.options), { currency: Object.assign(Object.assign({}, exports.jaJP.options.currency), { currencyDisplay: 'name' }) }) });
exports.esMX = {
    symbol: 'es-MX',
    dateFormat: types_1.DateFormat.DEFAULT,
    nameFormat: types_1.NameFormat.DEFAULT,
    options: {
        currency: {
            style: 'currency',
            currencyDisplay: 'symbol',
            currency: 'MXN',
        },
        decimal: {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        },
    },
};
exports.nlNL = {
    symbol: 'nl-NL',
    dateFormat: types_1.DateFormat.DEFAULT,
    nameFormat: types_1.NameFormat.DEFAULT,
    options: {
        currency: {
            style: 'currency',
            currencyDisplay: 'symbol',
            currency: 'EUR',
        },
        decimal: {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        },
    },
};
exports.plPL = {
    symbol: 'pl-PL',
    dateFormat: types_1.DateFormat.DEFAULT,
    nameFormat: types_1.NameFormat.DEFAULT,
    options: {
        currency: {
            style: 'currency',
            currencyDisplay: 'symbol',
            currency: 'PLN',
        },
        decimal: {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        },
    },
};
exports.ptBr = {
    symbol: 'pt-BR',
    dateFormat: types_1.DateFormat.DEFAULT,
    nameFormat: types_1.NameFormat.DEFAULT,
    options: {
        currency: {
            style: 'currency',
            currencyDisplay: 'symbol',
            currency: 'BRL',
        },
        decimal: {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        },
    },
};
exports.zhHans = {
    symbol: 'zh-Hans',
    dateFormat: types_1.DateFormat.DEFAULT,
    nameFormat: types_1.NameFormat.DEFAULT,
    options: {
        currency: {
            style: 'currency',
            currencyDisplay: 'symbol',
            currency: 'CNY',
        },
        decimal: {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        },
    },
};
exports.ptPT = {
    symbol: 'pt-PT',
    dateFormat: types_1.DateFormat.DEFAULT,
    nameFormat: types_1.NameFormat.DEFAULT,
    options: {
        currency: {
            style: 'currency',
            currencyDisplay: 'symbol',
            currency: 'EUR',
        },
        decimal: {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        },
    },
};
exports.thTH = {
    symbol: 'th-TH',
    dateFormat: types_1.DateFormat.DEFAULT,
    nameFormat: types_1.NameFormat.DEFAULT,
    options: {
        currency: {
            style: 'currency',
            currencyDisplay: 'symbol',
            currency: 'THB',
        },
        decimal: {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        },
    },
};
exports.enGB = {
    symbol: 'en-GB',
    dateFormat: types_1.DateFormat.DEFAULT,
    nameFormat: types_1.NameFormat.DEFAULT,
    options: {
        currency: {
            style: 'currency',
            currencyDisplay: 'symbol',
            currency: 'GBP',
        },
        decimal: {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        },
    },
};
exports.enCA = {
    symbol: 'en-CA',
    dateFormat: types_1.DateFormat.DEFAULT,
    nameFormat: types_1.NameFormat.DEFAULT,
    options: {
        currency: {
            style: 'currency',
            currencyDisplay: 'symbol',
            currency: 'CAD',
        },
        decimal: {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        },
    },
};
exports.enAU = {
    symbol: 'en-AU',
    dateFormat: types_1.DateFormat.DEFAULT,
    nameFormat: types_1.NameFormat.DEFAULT,
    options: {
        currency: {
            style: 'currency',
            currencyDisplay: 'symbol',
            currency: 'AUD',
        },
        decimal: {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        },
    },
};
//# sourceMappingURL=index.js.map